import gsap from 'gsap';

export const triggerEventEmitter = ( setting, timers, index ) => {
	let events = [],
		actions = [];
	setting?.settings?.forEach( ( ele, i ) => {
		events[ i ] = ele.event;
		actions[ i ] = ele.action || 'init';
	} );

	const execute = () => {
		events.forEach( ( ele, i ) => {
			if ( ele && actions[ i ] ) {
				ele[ actions[ i ] ]();
			}
		} );
	};

	const run = () => {
		timers[ index ]?.kill();
		timers[ index ] = null;
		if ( setting.delay ) {
			timers[ index ] = gsap.delayedCall( setting.delay, execute );
		} else {
			execute();
		}
	};

	const kill = () => {
		events = [];
		actions = [];
	};

	return { run, kill };
};
